import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=4fcb5ac0&"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/components/announcement-bar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports